module.exports = __webpack_public_path__ + "img/1首页产品图-家居.e76cfcab.png";